/* eslint-disable jsx-a11y/anchor-is-valid */
//#region component definition
export const TopBar: React.FC = () => {
  return (
    <section className="top-bar">
      <section className="top-bar-brand">
        <a href="">רות דואק</a>
      </section>
      <section className="top-bar-links">
        <a href="#Contact">צור קשר</a>
      </section>
    </section>
  );
}
//#endregion